import React from "react";
import {
  MobileWarning,
  MobileIcon,
  MobileInfo,
  MobileInfoTitle,
  MobileText,
} from "./productReviewMobileWarningStyles.js";

export const ProductReviewMobileWarning = () => {
  return (
    <MobileWarning>
      <MobileIcon>
        <img src="./images/black-icon_circle_info.svg" />
      </MobileIcon>
      <MobileInfo>
        <MobileInfoTitle>Desktop Recommended:</MobileInfoTitle>
        <MobileText>
          This is not a recommended experience to review action requests. To
          optimize your experience please switch to a desktop browser.
        </MobileText>
      </MobileInfo>
    </MobileWarning>
  );
};
